<mat-paginator [length]="pagination.totalCount"
               [pageSize]="pagination.pageSize"
               [pageIndex]="pagination.currentPage"
               [pageSizeOptions]="[100, 250, 500]"
               (page)="selectPage($event)"
               [showFirstLastButtons] = "true">
</mat-paginator>
